import { render, staticRenderFns } from "./RouteDetail.vue?vue&type=template&id=f6844766"
import script from "../../controllers/route/route-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/route/route-detail.js?vue&type=script&lang=js&external"
import style0 from "./RouteDetail.vue?vue&type=style&index=0&id=f6844766&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports